import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id BCCF75AE-F73D-4B7A-BDFD-9E767DED0B28
 * name image-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-multiple-outline.svg
 * tags
 * - Photography 
 */
export const ImageMultipleOutlineIcon = createSvgIcon(<><path d="M21,17H7V3H21M21,1H7A2,2 0 0,0 5,3V17A2,2 0 0,0 7,19H21A2,2 0 0,0 23,17V3A2,2 0 0,0 21,1M3,5H1V21A2,2 0 0,0 3,23H19V21H3M15.96,10.29L13.21,13.83L11.25,11.47L8.5,15H19.5L15.96,10.29Z" /></>, 'ImageMultipleOutlineIcon');
export default ImageMultipleOutlineIcon